declare const window: any;

export class DeviceHelpers {
    public static isIOS() {
        return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    }
}